import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Dispatcher = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `let http=require("http")

//Serve per parsare l'url. All'interno dell'url troviamo --> protocollo usato (http o https), mome di dominio (www.denina.it), parametri passati, come sono passati (GET o POST)
let url=require("url")

http.createServer((req,res)=>{
    let mioURL=url.parse(req.url,true)
    switch (mioURL.path) {
        case "/":
            res.end("Home Page")
            break;
        case "/pluto":
            res.end("Pluto")
            break;
        case "/topolino":
            res.end("Topolino")
            break;
    
        default:
            break;
    }
}).listen("3000")`;

  return (
    <div className="container-fluid">
    	<div className="div-intro">
			<div data-aos="fade-right">
			<h1>Dispatcher</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
			<br/>
			<div data-aos="fade-right">
			<h4>Cos'è e a cosa serve il dispatcher</h4>
			<p>
Il <strong>dispatcher</strong> serve a gestire le pagine del nostro sito. Permette infatti di gestire più url attraverso, ad esempio, uno switch.</p>
			</div>
			<br/><br/>
<div data-aos="fade-right">
<h4>Progetto dispatcher (<a href="Progetto_3_Dispatcher.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di utilizzo del dispatcher:</p>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice1}
</code></pre>
</div>
		</div>
    </div>
  );
};

export default Dispatcher;
